import '../styles/overlay.less';
import $ from 'jquery';
import * as common from '../../../shared/modules/common';

var functionNames = ['init', 'hide', 'show'];

/**
 * A class which represents a Overlay widget.
 * This defines the structure and the main behavior of the widget.
 *
 * @param $markup The jQuery element which is the Overlay markup.
 */
function Overlay(config) {
    var $view,
        baseZIndex = config.$markup.css('z-index'),
        overlayIndex;

    function createView() {
        if ($view) {
            $view.remove();
        }
        $view = config.$markup.clone(true, true).appendTo(config.$parent);
        $view.removeAttr('id');
        $view.addClass('uwr-overlay-view');
    }

    function orderVisibleOverlays(removedOverlayIndex) {
        $('.uwr-overlay:visible').each(function () {
            var visibleOverlay = $(this).data('uwrWidget'),
                visibleOverlayIndex = visibleOverlay.getOverlayIndex();
            if (visibleOverlayIndex > removedOverlayIndex) {
                visibleOverlay.setOverlayIndex(visibleOverlayIndex - 1);
            }
        });
    }

    this.init = function (callback) {
        common.invoke(callback);
    };

    this.show = function (callback) {
        var notVisibleIncrement = + 1 - this.getView().is(':visible'),
            newOverlayIndex = $('.uwr-overlay:visible').size() + notVisibleIncrement;
        orderVisibleOverlays(overlayIndex);
        this.setOverlayIndex(newOverlayIndex);
        this.getView().show(0, callback);
    };

    this.hide = function (callback) {
        this.getView().hide(0, callback);
        this.getView().css('z-index', baseZIndex);
        this.setOverlayIndex(undefined);
        orderVisibleOverlays(overlayIndex);
    };

    this.getView = function () {
        if ($view === undefined) {
            createView();
        }
        return $view;
    };

    this.getOverlayIndex = function () {
        return overlayIndex;
    };

    this.setOverlayIndex = function (newOverlayIndex) {
        overlayIndex = newOverlayIndex ? newOverlayIndex : 0;
        $view.css('z-index', baseZIndex + overlayIndex);
    };
}

export function hide(selector, callback) {
    var overlay = $(selector).data('uwrWidget');
    if (overlay && overlay.hide) {
        overlay.hide(callback);
    }
}

export function show(selector, callback) {
    var overlay = $(selector).data('uwrWidget');
    if (overlay && overlay.show) {
        overlay.show(callback);
    }
}

/**
 * Initialize the selected Overlay(s)
 * Supported use cases:
 *   - init();
 *   - init(callback);
 *   - init(selector);
 *   - init(selector, callback);
 * @param selector CSS selector string that returns the elements that need to be initialized.
 *   Optional: If not passed in, then all elements marked with "uwr-overlay" CSS class will be processed.
 * @param callback The function to run after initialization (optional).
 */
export function init(selector, callback) {
    var widget,
        callbackWithoutSelector = arguments.length === 1 && typeof selector === 'function';
    if (arguments.length === 0 || callbackWithoutSelector) {
        $('.uwr-overlay').each(function () {
            var config = {
                    $markup: $(this),
                    $parent: $($(this).data('parent') || $(this).parent())
                };
            widget = new Overlay(config);
            $(this).data('uwrWidget', widget);
        });
        if (callbackWithoutSelector) {
            common.invoke(selector);
        }
    } else {
        widget = new Overlay($(selector));
        $(selector).data('uwrWidget', widget);
        common.invoke(callback);
    }
    return widget;
}

function WidgetList(methods) {
    var widgetArray = [],
        i,
        methodName;

    function createMethodMediator(methodName) {
        return function () {
            var j;
            for (j = 0; j < widgetArray.length; j++) {
                widgetArray[j][methodName](arguments);
            }
        };
    }

    this.length = function () {
        return widgetArray.length;
    };

    this.get = function (index) {
        return widgetArray[index];
    };

    this.push = function (item) {
        if (item) {
            widgetArray.push(item);
        }
    };

    for (i = 0; i < methods.length; i++) {
        methodName = methods[i];
        this[methodName] = createMethodMediator(methodName);
    }
};

export default function overlay(selector) {
    var $elements = $('.uwr-overlay' + (selector || '')),
        overlayList = new WidgetList(functionNames),
        widget;
    $elements.each(function () {
        widget = $(this).data('uwrWidget');
        overlayList.push(widget);
    });
    return overlayList;
}






//////////////////
// WEBPACK FOOTER
// ./widgets/Overlay/js/overlay.js
// module id = 35
// module chunks = main